<template>
	<div class="share-story-container">
		<div class="share-story-content">
			<p>{{`${$t('buttons.showcase')}`}}<br>{{`${$t('buttons.helpDriveSales')}`}}</p>
			<div class="button-wrapper">
				<button @click="goToSubmissionForm">
					<span class="not-mobile">{{`${$t('buttons.shareStory')}`}}</span>
					<span class="mobile">{{`${$t('buttons.share')}`}}</span>
					<img :src="require('@/drc/assets/icons/arrows/arrow-top-right.svg')" alt=">">
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

export default {
	name: "ShareStoryLine",
	methods: {
		goToSubmissionForm() {
			const now = new Date();
			this.$gtag.event("SHARE_STORY", {
				event_type: "button",
				event_category: "drc",
				event_page: "sticky-share-story-line",
				event_label: "Clicked share your story button",
				event_location: this.$route.name,
				event_path: this.$route.path,
				user_id: this.$store.getters.getUser.id,
				user_name: this.$store.getters.getUser.fullName,
				user_email: this.$store.getters.getUser.email,
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
				time: new Date().toJSON().split('T')[1].split('.')[0]
			});
			const props = {
				action: "SHARE_STORY",
				comment: JSON.stringify({location: "DRC_SHARE_STORY_LINE", type: "BUTTON_CLICK"})
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
			this.$router.push("/submission/new-project-form")
		},
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.share-story-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	background: linear-gradient(90deg, #FFB81C 0%, #00E7FF 100%);
	position: sticky;
	top: 0;
	padding: 16px 6%;
	z-index: 4;

	.share-story-content {
		width: 100%;
		max-width: 1440px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-self: center;
		align-items: center;
		gap: 25px;

		@media (max-width: 400px) {
			flex-direction: column;
			gap: 5px;
		}

		p {
			display: inline-block;
			font-family: Tiempos Text, serif;
			font-weight: 400;
			font-size: 18px;
			line-height: 21px;
			letter-spacing: 0.36px;
			color: #0e2b40;

			@media (max-width: $mobile) {
				font-size: 12px;
				line-height: 14px;
			}

			@media (max-width: 400px) {
				margin-top: 0;
				margin-bottom: 0;
			}
		}

		.button-wrapper {
			overflow: hidden;
			width: fit-content;
			border-right: 1px solid transparent;
			height: fit-content;
			transition: all 0.4s ease-in-out;

			@media (max-width: $mobile) {
				overflow: unset;
			}

			&:hover {
				border-right: 1px solid #001F33;
			}

			button {
				background-color: #001F33;
				padding: 12px 16px;
				color: #FCFCFE;
				height: fit-content;
				align-self: center;
				cursor: pointer;
				border-left: 1px solid transparent;
				border-right: 1px solid transparent;
				border-bottom: 1px solid transparent;
				border-top: 1px solid transparent;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-items: center;
				position: relative;
				right: -30px;
				transition: all 0.4s ease-in-out;

				@media (max-width: $mobile) {
					padding: 8px 12px;
					right: 0;
				}

				span {
					text-transform: uppercase;
					font-family: Roboto, sans-serif;
					font-weight: 400;
					font-size: 15px;
					line-height: 20px;
					letter-spacing: 0;
					color: white;
					transition: all 0.4s ease-in-out;
				}

				.not-mobile {
					display: block;

					@media (max-width: $mobile) {
						display: none;
					}
				}

				.mobile {
					display: none;

					@media (max-width: $mobile) {
						display: block;
					}
				}

				img {
					width: 20px;
					height: 20px;
					margin-left: 10px;

					@media (max-width: $mobile) {
						display: none;
					}
				}

				&:hover {
					right: 0;
					background-color: transparent;
					border-left: 1px solid #001F33;
					border-top: 1px solid #001F33;
					border-bottom: 1px solid #001F33;

					span {
						color: #001F33;
					}

					img {
						right: 0;
					}
				}
			}
		}

	}
}
</style>
